export default "__VITE_ASSET__BuesKOoy__"